/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SyncPrimaryStoredValueBalanceRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/SyncPrimaryStoredValueBalance.pb'
import {SyncPrimaryStoredValueBalanceResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/SyncPrimaryStoredValueBalance.pb'


export const syncPrimaryStoredValueBalance = (request:SyncPrimaryStoredValueBalanceRequest, options?: CashRequestOptions) => post<SyncPrimaryStoredValueBalanceRequest, SyncPrimaryStoredValueBalanceResponse>("/2.0/cash/sync-primary-stored-value-balance", request, {...options, rejectOnError: true })